var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subscription-list-empty"
  }, [_c('div', {
    staticClass: "layout-background"
  }, [_c('subscription-empty-list-animation')], 1), _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('try.subscription.service')) + " ")]), _c('div', {
    staticClass: "text-medium"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('need.regular.audience.support')) + " ")]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('course.lasts.several.months')) + " ")]), _c('p', [_vm._v(" " + _vm._s(_vm.$t('can.use.private.chat.only.for.fee')) + " ")])]), _c('div', {
    staticClass: "button-container"
  }, [_c('a', {
    staticClass: "button thin action",
    on: {
      "click": _vm.onRouteSubscription
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('create.bill.subscription')))])])]), _c('div', {
    staticClass: "text-small",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('show.subscribers.list.after.first.successful.payment'))
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }